module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=IR - Iran.9f1e2625.svg";